module.exports = __webpack_public_path__ + "assets/img/reserve-type-icon3.aa43c6c2.png";